import { i18n } from "@/plugins/i18n";

export class smsMessage {
  columns = [];
  id = "id";

  fillAbles = [
    ["customer.name", i18n.t("customer"), true],
    ["phoneNumber", i18n.t("phoneNumber"), true],
    ["textMessage", i18n.t("textMessage"), true],
    ["createdAt", i18n.t("date"), true],
    ["note", i18n.t("note"), true],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility: true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
